import { KtznEventSubscriptionAction } from "@/framework/store/ktznEventSubscription/types";

export default {
  [KtznEventSubscriptionAction.startWebsocketConnection]({ commit }: any, payload: boolean) {
    // value will be received in 'src/share_modules/plugins/ktznEventStoreSubscription.ts'
  },
  [KtznEventSubscriptionAction.stopWebsocketConnection]({ commit }: any, payload: boolean) {
    // value will be received in 'src/share_modules/plugins/ktznEventStoreSubscription.ts'
  },
  [KtznEventSubscriptionAction.subscribeToConversations]({ commit }: any, conversationIds: string[]) {
    // value will be received in 'src/share_modules/plugins/ktznEventStoreSubscription.ts'
  },
  [KtznEventSubscriptionAction.unsubscribeFromConversations]({ commit }: any, conversationIds: string[]) {
    // value will be received in 'src/share_modules/plugins/ktznEventStoreSubscription.ts'
  },
  [KtznEventSubscriptionAction.subscribeToConversation]({ commit }: any, conversationIds: string) {
    // value will be received in 'src/share_modules/plugins/ktznEventStoreSubscription.ts'
  },
  [KtznEventSubscriptionAction.unsubscribeFromConversation]({ commit }: any, conversationIds: string) {
    // value will be received in 'src/share_modules/plugins/ktznEventStoreSubscription.ts'
  },
  [KtznEventSubscriptionAction.subscribeToTenant]({ commit }: any, tenantId: number) {
    // value will be received in 'src/share_modules/plugins/ktznEventStoreSubscription.ts'
  },
  [KtznEventSubscriptionAction.unsubscribeFromTenant]({ commit }: any, tenantId: number) {
    // value will be received in 'src/share_modules/plugins/ktznEventStoreSubscription.ts'
  },
  [KtznEventSubscriptionAction.subscribeToUser]({ commit }: any, accessId: string) {
    // value will be received in 'src/share_modules/plugins/ktznEventStoreSubscription.ts'
  },
  [KtznEventSubscriptionAction.unsubscribeFromUser]({ commit }: any, accessId: string) {
    // value will be received in 'src/share_modules/plugins/ktznEventStoreSubscription.ts'
  },
  [KtznEventSubscriptionAction.unsubscribeFromAllEvents]({ commit }: any) {
    // value will be received in 'src/share_modules/plugins/ktznEventStoreSubscription.ts'
  },
};
